var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-template-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-template-icon-group2",
    transform: "translate(-700.000000, -204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-template-icon-group2",
    transform: "translate(700.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-template-icon-group3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "document-template-icon-rect1",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9574468,4.08510638 L12.1276596,4.08510638 C9.95106383,4.08510638 8.19,5.87744681 8.19,8.06808511 L8.17021277,39.9319149 C8.17021277,42.1225532 9.9312766,43.9148936 12.1078723,43.9148936 L35.8723404,43.9148936 C38.0489362,43.9148936 39.8297872,42.1225532 39.8297872,39.9319149 L39.8297872,16.0340426 L27.9574468,4.08510638 Z M35.8723404,39.9319149 L12.1276596,39.9319149 L12.1276596,8.06808511 L25.9787234,8.06808511 L25.9787234,18.0255319 L35.8723404,18.0255319 L35.8723404,39.9319149 Z",
    id: "document-template-icon-path1",
    fill: "#8996A4",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "document-template-icon-group4",
    transform: "translate(18.000000, 21.000000)",
    fill: "#718191",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0021716,3.64205482e-07 C3.57524408,-0.000842247191 1.38681877,1.4604549 0.457489652,3.70240166 C-0.471839466,5.94434843 0.0409730377,8.52535948 1.75677193,10.2417545 C3.47257083,11.9581496 6.05340357,12.4718587 8.29567305,11.5433085 C10.5379425,10.6147583 12,8.42684082 12,5.99991315 C12,2.68706671 9.31501784,0.00115142218 6.0021716,3.64205482e-07 Z M6.0021716,9.70739697 C4.50141274,9.70823927 3.14799867,8.80474129 2.57329369,7.41838201 C1.9985887,6.03202273 2.31583106,4.43596649 3.377028,3.37476955 C4.43822494,2.31357262 6.03428118,1.99633026 7.42064046,2.57103524 C8.80699974,3.14574022 9.71049771,4.49915429 9.70965542,5.99991315 C9.70850509,8.04702317 8.04928162,9.70624664 6.0021716,9.70739697 L6.0021716,9.70739697 Z",
    id: "document-template-icon-path2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "document-template-icon-polygon1",
    transform: "translate(6.110541, 13.972357) rotate(-90.000000) translate(-6.110541, -13.972357) ",
    points: "5.1070822 12.0258759 7.11399976 12.0258759 7.11399976 15.9188375 5.1070822 15.9188375"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateDocumentIcon);
export default __webpack_public_path__ + "static/media/template-document-icon.d581a625.svg";
export { ForwardRef as ReactComponent };